import React, { useState } from "react";
import "./styles/menu.css";

const menuData = [
  { item: "VANILA", pastry: 50, oneP: 280, twoP: 560 },
  { item: "PINEAPPLE", pastry: 50, oneP: 300, twoP: 600 },
  { item: "STRAWBERRY", pastry: 50, oneP: 300, twoP: 600 },
  { item: "BUTTERSCOTCH", pastry: 50, oneP: 300, twoP: 600 },
  { item: "WHITE FOREST", pastry: 50, oneP: 330, twoP: 660 },
  { item: "BLACK FOREST", pastry: 50, oneP: 300, twoP: 600 },
  { item: "CHOCO CHIPS", pastry: 50, oneP: 320, twoP: 640 },
  { item: "CASATA", pastry: 60, oneP: 330, twoP: 660 },
  { item: "CHOCOLATE TRUFFLE", pastry: 60, oneP: 350, twoP: 700 },
  { item: "RED VELVET", pastry: 60, oneP: 350, twoP: 700 },
  { item: "RAS MALAI", pastry: 60, oneP: 450, twoP: 900 },
  { item: "GOLDEN MAGIC", pastry: 70, oneP: 450, twoP: 900 },
  { item: "SILK CHOCOLATE", pastry: 70, oneP: 450, twoP: 900 },
  { item: "BELGIUM CHOCOLATE", pastry: 70 },
  { item: "SWISS ROLL", pastry: 50 },
  { item: "DONAT", pastry: 50 },
  { item: "JAM ROLL", pastry: 40 },
];

const Menu = () => {
  const [cart, setCart] = useState([]);

  const addToCart = (item) => {
    setCart([...cart, item]);
  };

  const placeOrder = () => {
    const message = cart
      .map((item) => `${item.item} - ₹${item.pastry}`)
      .join("%0A");
    const url = `https://wa.me/919669143999?text=Order%20Details:%0A${message}`;
    window.open(url, "_blank");
  };

  return (
    <div className="menu">
      <h1>Our Menu</h1>
      <div className="menu-items">
        {menuData.map((item, index) => (
          <div className="menu-item" key={index}>
            <h3>{item.item}</h3>
            <p>Pastry: ₹{item.pastry}</p>
            <p>1P: ₹{item.oneP}</p>
            <p>2P: ₹{item.twoP}</p>
            <button onClick={() => addToCart(item)}>Add to Cart</button>
          </div>
        ))}
      </div>

      {/* Order Summary Section */}
      <div className="order-summary">
        <h2>Order Summary</h2>
        {cart.map((item, index) => (
          <p key={index}>
            {item.item} - ₹{item.pastry}
          </p>
        ))}
        <button onClick={placeOrder}>Place Order on WhatsApp</button>
      </div>

      {/* Visit Store Section */}
      <div className="visit-store">
        <h2>For complete menu and variety of products</h2>
        <p>You can visit our store. We have a lot more to offer you!</p>
      </div>
    </div>
  );
};

export default Menu;
